import { useState, useEffect } from 'react';
import { whatsappApi } from "../../../features/whatsapp/api/whatsapp-api";
import apiClient from "../../../api/core/apiClient";

export type ChannelType = 'WhatsApp' | 'Correo';

export type TemplateOption = {
    label: string;
    value: string;
    channel: ChannelType;
};

export const useTemplatesModal = (isOpen: boolean) => {
    const [channel, setChannel] = useState<ChannelType>('WhatsApp');
    const [templates, setTemplates] = useState<TemplateOption[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (!isOpen) return;

        const fetchTemplates = async () => {
            setIsLoading(true);
            setError(null);
            try {
                if (channel === 'WhatsApp') {
                    const response: any = await whatsappApi.getTemplates();
                    setTemplates(response.map((t: any) => ({
                        label: t.name,
                        value: t.id,
                        channel: 'WhatsApp'
                    })));
                } else if (channel === 'Correo') {
                    const response: any = await apiClient.get('/crm/email_template');
                    setTemplates(response.map((t: any) => ({
                        label: t.friendlyName,
                        value: t.id,
                        channel: 'Correo'
                    })));
                }
            } catch (err) {
                setError(`No se pudieron cargar las plantillas de ${channel}. Inténtelo de nuevo.`);
                console.error("Error fetching templates:", err);
            } finally {
                setIsLoading(false);
            }
        };

        fetchTemplates();
    }, [isOpen, channel]);

    // Reset state when modal closes
    useEffect(() => {
        if (!isOpen) {
            setChannel('WhatsApp');
            setTemplates([]);
            setError(null);
        }
    }, [isOpen]);

    return {
        channel,
        setChannel,
        templates,
        isLoading,
        error
    };
};
